module.exports = __webpack_public_path__ + "img/avatar6.76f82c51.png";